export default __webpack_public_path__ + "static/media/debate_4.2875d2ea.JPG";